module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Qa6SDo/tc-custom/9781524852726.jpg?1708400931369",
      "alt": "This image is the cover for the book Sparks of Phoenix"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sparks of Phoenix\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("As the phoenix emerges from its ashes, Zebian emerges ablaze in these pages, not only as a survivor of abuse, but as a teacher and healer for all those who have struggled to understand, reclaim, and rise above a history of pain."), _c('br'), _c('br'), _vm._v("The book is divided into six chapters, and six stages of healing: Falling, Burning to Ashes, Sparks of Phoenix, Rising, Soaring, and finally, A New Chapter, which demonstrates a healthy response to new love as the result of authentic healing."), _c('br'), _c('br'), _vm._v("With her characteristic vulnerability, courage, and softness, Zebian seeks to empower those who have been made to feel ashamed, silenced, or afraid; she urges them, through gentle advice and personal revelation, to raise their voices, rise up, and soar."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Najwa Zebian\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0